import { registerBuiltinPatterns } from './patterns';
import { registerBuiltinShapes } from './shapes';
import { registerBuiltinProviders } from './texture';

/**
 * Core entry point.
 *
 * `initializeCore` fills the three registries. It is idempotent, so the app,
 * the export worker and every test file can call it without coordinating.
 */
export function initializeCore(): void {
  registerBuiltinPatterns();
  registerBuiltinShapes();
  registerBuiltinProviders();
}

export * from './types';
export * from './params';
export * from './blend';
export * from './wall';
export * from './heightfield';
export * from './patterns';
export * from './shapes';
export * from './mesh/panelMesh';
export * from './export';
export * from './design/constraints';
export * from './design/defaults';
export * from './design/validate';
export * from './design/serialize';
export * from './texture';
